import {api} from "./service.js";
import metainfo from "../data/metaInfo/index.js";	
import industryInfo from "../data/industryInfo/index.js";		
const industry={
	getIndustry(id){
		return api.post("pc/industry/page",{id:id});
	},
	getIndustryAndClassname(id,classname){
		return api.post("pc/industry/page",{id:id,classname:classname});
	},
	//行业提交需求
	saveNeeds(info){
		return api.post("pc/contact/add",info)
	},
	getmetaInfo(id){
		var info = {};
		id = id+"";
		switch(id) {
			case "1":
			   info = metainfo.metainfo1			   
			   break;
			case "2":
				info = metainfo.metainfo2
			   break;
			case "3":
				info =  metainfo.metainfo3
				break;
			case "4":
				info =  metainfo.metainfo4
				break;
			case "5":
				info =  metainfo.metainfo5
				break;
			case "6":
				info =  metainfo.metainfo6
				break;
			case "7":
				info =  metainfo.metainfo7
				break;
			case "8":
				info =  metainfo.metainfo8
				break;
			case "9":
				info =  metainfo.metainfo9
				break;
			default:
				info =  metainfo.metainfo9
	   } 
	   return info;
	},
	getIndustryInfo(id){
		var info = {};
		id = id+""
		//console.log(id)
		switch(id) {
			case "1":
			   info = industryInfo.industryInfo1			   
			   break;
			case "2":
				info = industryInfo.industryInfo2
			   break;
			case "3":
				info =  industryInfo.industryInfo3
				break;
			case "4":
				info =  industryInfo.industryInfo4
				break;
			case "5":
				info =  industryInfo.industryInfo5
				break;
			case "6":
				info =  industryInfo.industryInfo6
				break;
			case "7":
				info =  industryInfo.industryInfo7
				break;
			case "8":
				info =  industryInfo.industryInfo8
				break;
			case "9":
				info =  industryInfo.industryInfo9
				break;
			case "10":
				info =  industryInfo.industryInfo10
				break;
			case "11":
				info =  industryInfo.industryInfo11
				break;
			default:
				info =  industryInfo.industryInfo1
	   } 
	   return info;
	}
}
export default industry;


// WEBPACK FOOTER //
// ./src/service/industry.js